query MobileDashboardMfaSessions(
	$offset: Int!
	$limit: Int!
	$sort: mfa_session_runsSort
	$daysAmountFilter: ConditionInt
	$customFieldsFilter: ConditionStringArray
	$customFieldsFilterExcludes: ConditionStringArray
	$mfaOsFilter: ConditionString
	$mfaAppIdFilter: ConditionStringArray
) {
	mfa_session_runs(
		offset: $offset
		limit: $limit
		sort: $sort
		run_updated_at_last_n_days: $daysAmountFilter
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
	) {
		run_id
		session_name
		total_issues
		critical_issues
		serious_issues
		run_updated_at
		user_name
	}
	total: mfa_session_runs(
		run_updated_at_last_n_days: $daysAmountFilter
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
	) {
		run_id_count
	}
	unfiltered_total: mfa_session_runs {
		run_id_count
	}
}
